import { ApiError } from '@sonar/errors';
import { Period, Reference, TimeAggregate, TimeSlot } from '@sonar/models';

import { Result } from '../Reports';

import { AggregatedOrderInfo } from './types';
import useOrdersQuery from './useOrdersQuery';

interface UseOrdersAggregatedParams {
  storeIds: number[];
  timeAggregate: TimeAggregate;
  period: Period;
  timeSlot: TimeSlot;
  referenceCode?: Reference;
  isTrainingMode?: boolean;
  // TODO: (#ORE-1467) Remove this prop when all users are migrated to new reports
  canRequestReports?: boolean;
}

interface UseOrdersAggregatedResult {
  error?: ApiError;
  isLoading: boolean;
  isError: boolean;
  selected: Result<AggregatedOrderInfo>;
  reference?: Result<AggregatedOrderInfo>;
}

function useOrdersAggregated({
  storeIds,
  timeAggregate,
  period,
  timeSlot,
  referenceCode,
  isTrainingMode = false,
  canRequestReports = true,
}: UseOrdersAggregatedParams): UseOrdersAggregatedResult {
  const { data = [], error, isLoading, isError } = useOrdersQuery({
    storeIds,
    period,
    timeSlot,
    isTrainingMode,
    referenceCode,
    timeAggregate,
    canRequestReports,
  });

  const [selected = {}, reference = undefined] = data;

  return { error: error ?? undefined, isLoading, isError, selected, reference };
}

export default useOrdersAggregated;
